import React, { useState } from 'react';
import {
  useShowListEditOptionContext,
  useShowListEditBoxContext,
  useActiveListContext,
} from '../../../context';
import { DeleteList } from './delete-list';
import { COLORS, COLORS_L2 } from '../../../constants';
import { DndList } from '../../dnd_list';
import { Core } from '../..';
import { FaGripVertical, FaTrashAlt, FaInfoCircle } from 'react-icons/fa';
import { ItemContainer } from './styles';
import { OnlyHover } from '../../../media_queries';

export const IndividualList = ({
  list,
  dragSnapshot,
  listRefs,
  listIndex,
  listTotal,
  setShowTasks = null,
  setProgress,
  isInDelete,
  setIsInDelete,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const { showListEditOption } = useShowListEditOptionContext();
  const [showBox, setShowBox] = useState(false);
  const { setShowListEditBox, setTargetEditList } = useShowListEditBoxContext();
  const { activeList, setActiveList } = useActiveListContext();

  return (
    <>
      <DndList.Item
        total={listTotal}
        number={listIndex + 1}
        isOnDrag={dragSnapshot.isDragging}
        isActive={activeList == list.docID}
        color_l2={COLORS_L2[list.color]}
        deletePrompt={showBox}
        style={{
          padding: '15px 10px',
          background: 'white',
          display: 'block',
          position: 'relative',
          opacity: isInDelete ? 0.6 : 1,
        }}
        onMouseLeave={() => setShowOptions(false)}
      >
        <OnlyHover showBox={showListEditOption}>
          {!showBox && (
            <Core.HoverHandle
              color={COLORS[list.color]}
              onMouseEnter={() => setShowOptions(true)}
              style={{
                position: 'absolute',
                left: 0,
                top: '50%',
                marginLeft: '10px',
                transform: 'translateY(-50%)',
                cursor: 'grab',
                visibility:
                  dragSnapshot.isDragging || showListEditOption || showOptions
                    ? 'visible'
                    : 'hidden',
              }}
            >
              <FaGripVertical className='icon' />
            </Core.HoverHandle>
          )}
        </OnlyHover>

        <OnlyHover showBox={showListEditOption}>
          {!showBox &&
            (showListEditOption ||
              (!dragSnapshot.isDragging && showOptions)) && (
              <div
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 99,
                  display: 'flex',
                }}
                onMouseEnter={() => setShowOptions(true)}
              >
                <Core.HoverHandle
                  style={{
                    marginRight: '8px',
                  }}
                  color={'#ea4e3d'}
                  onClick={() => setShowBox(true)}
                >
                  <FaTrashAlt className='icon' />
                </Core.HoverHandle>
                <Core.HoverHandle
                  style={{
                    marginRight: '10px',
                  }}
                  color={COLORS[list.color]}
                  onClick={() => {
                    setShowListEditBox(true);
                    setTargetEditList(list);
                  }}
                >
                  <FaInfoCircle className='icon' />
                </Core.HoverHandle>
              </div>
            )}
        </OnlyHover>

        {!showBox && (
          <>
            <ItemContainer
              style={{
                cursor: 'pointer',
                paddingLeft: '40px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
              ref={(ref) => (listRefs[listIndex] = ref)}
              onClick={() => {
                setActiveList(list.docID);

                if (setShowTasks) setShowTasks(true);
              }}
              onMouseEnter={() => setShowOptions(true)}
              onMouseLeave={() => setShowOptions(false)}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    borderRadius: '50%',
                    width: '10px',
                    height: '10px',
                    marginRight: '5px',
                    background: COLORS[list.color],
                  }}
                ></span>
                <span
                  style={{
                    wordBreak: 'break-all',
                    flex: 1,
                    fontWeight: 'bold',
                    opacity: activeList == list.docID ? 1 : 0.8,
                  }}
                >
                  {list.name}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px',
                  opacity: 0.6,
                }}
              >
                {list.taskCount ? list.taskCount : 0}
              </div>
            </ItemContainer>
          </>
        )}

        {showBox && (
          <DeleteList
            setIsInDelete={setIsInDelete}
            setShowBox={setShowBox}
            setProgress={setProgress}
            list={list}
          />
        )}
      </DndList.Item>
    </>
  );
};
